export default __webpack_public_path__ + "static/ETLS_2024-961c3c9ac6d238c2167ef8470aaf291a.png";